<template>
    <div ref="menuContainer" class="menu-container ms-auto">
        <slot name="menu-button">
            <IconButton preset="kebab" @click="toggleMenu" />
        </slot>

        <Transition name="dropdown-fade">
            <div v-if="showMenu" class="menu-dropdown menu-dropdown-offset">
                <div
                    v-for="(item, index) in menuItems"
                    :key="index"
                    class="d-flex align-items-center w-100"
                    :class="{ 'border-bottom': index < menuItems.length - 1 }"
                    @click="handleMenuClick(item)"
                >
                    <label>{{ item.label }}</label>
                    <i class="fi fi-chevron-right ms-auto"></i>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script>
import IconButton from './IconButton.vue';

export default {
    name: 'KebabMenu',
    components: {
        IconButton,
    },
    props: {
        // Array of objects with label and event properties
        // Example: [{ label: 'View Areas', click: 'view-areas' }, { label: 'View Sites', click: 'view-sites' }]
        menuItems: {
            type: Array,
            default: () => [],
            validator: (items) => { 
                return items.every(
                    (item) =>
                        item &&
                        typeof item.label === 'string' &&
                        typeof item.click === 'string'
                );
            },
        },
    },
    data() {
        return {
            showMenu: false, // Controls visibility of the menu dropdown
        };
    },
    methods: {
        toggleMenu() {
            this.showMenu = !this.showMenu;
        },
        closeMenu(event) {
            if (!this.$refs.menuContainer.contains(event.target)) {
                this.showMenu = false;
            }
        },
        handleMenuClick(item) {
            this.$emit(item.click);
            this.toggleMenu();
        },
    },
    mounted() {
        document.addEventListener('click', this.closeMenu);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.closeMenu);
    },
};
</script>

<style scoped>
.menu-container {
    position: relative;
    display: inline-block;
}

.icon-btn {
    position: relative;
}

.menu-dropdown {
    position: absolute;
    margin-top: var(--space-2);
    right: 0;
    min-width: 13.75rem;
    max-width: 100vw;
    width: 100%;
    max-height: 50vh;
    background-color: var(--neutral-400);
    border-radius: var(--radius-default);
    border: 1px solid var(--neutral-600);
    padding: var(--space-2);
    z-index: 1060;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    pointer-events: auto;
    transform-origin: top right;

    /* Custom scrollbar styling */
    scrollbar-width: thin;
    scrollbar-color: var(--neutral-600) var(--neutral-400);
}

.menu-dropdown div {
    padding: var(--space-2);
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: background-color 0.3s ease, transform 0.2s ease,
        box-shadow 0.2s ease;
    border-radius: var(--radius-sm);
}

.menu-dropdown label {
    cursor: pointer;
}

.menu-dropdown div:hover {
    background-color: var(--neutral-500);
    /* Darker background on hover */
}

.menu-dropdown div:active {
    background-color: var(--neutral-600);
    /* Deeper inset shadow */
}

/* Webkit scrollbar styling */
.menu-dropdown::-webkit-scrollbar {
    width: 8px;
}

.menu-dropdown::-webkit-scrollbar-track {
    background: var(--neutral-400);
    border-radius: 4px;
}

.menu-dropdown::-webkit-scrollbar-thumb {
    background-color: var(--neutral-600);
    border-radius: 4px;
    border: 2px solid var(--neutral-400);
}

.menu-dropdown::-webkit-scrollbar-thumb:hover {
    background-color: var(--neutral-700);
}

.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
    transition: opacity 0.3s ease, transform 0.3s ease;
}

.dropdown-fade-enter-from,
.dropdown-fade-leave-to {
    opacity: 0;
    transform: translateY(-0.625rem) scale(0.95);
}

@media only screen and (max-width: 767.98px) {
    .menu-dropdown {
        max-height: 40vh;
    }
}
</style>
